import type {
  ConnectionStatusResponse,
  DisconnectGoogleResponse,
} from "@hz/common/api-types/auth";

import { api } from "@state/apiSlice";
import { Tags } from "@state/apiSlice/tags";

const connectionsRequestsSlice = api.injectEndpoints({
  endpoints: (build) => ({
    connectionStatus: build.query<ConnectionStatusResponse, object>({
      query: () => ({
        url: "/oauth/status",
        headers: {
          "Content-Type": "application/json",
        },
      }),
      providesTags: [{ type: Tags.ConnectionStatus }],
    }),
    disconnectGoole: build.mutation<DisconnectGoogleResponse, void>({
      query: () => ({
        url: "/oauth/google/disconnect",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {},
      }),
      invalidatesTags: [{ type: Tags.ConnectionStatus }],
    }),
  }),
});

export default connectionsRequestsSlice;
